<template>
    <div v-if="!!planningItem && !!workOrders">
        <div style="margin-top: 10px">
            <div class="md-body-2">Werkbon informatie</div>
            <div v-for="workOrder in workOrders" :key="workOrder.work_order_id">
                <div class="md-caption md-layout">
                    <div class="md-layout-item">Werkbon nummer:</div>
                    <div class="md-layout-item">{{ workOrder.work_order_id }}</div>
                </div>
                <div class="md-caption md-layout">
                    <div class="md-layout-item">Type:</div>
                    <div class="md-layout-item">{{ workOrder.work_order_type }}</div>
                </div>
                <div class="md-caption md-layout">
                    <div class="md-layout-item">Status:</div>
                    <div class="md-layout-item">{{ workOrder.status }}</div>
                </div>
                <div class="md-caption md-layout">
                    <div class="md-layout-item">Technieker:</div>
                    <div class="md-layout-item">{{ ownerLabel(workOrder) }}</div>
                </div>
                <div class="md-caption md-layout">
                    <div class="md-layout-item">Creatie datum:</div>
                    <div class="md-layout-item">{{ moment(workOrder.creation_date).format('DD/MM/YYYY HH:mm') }}</div>
                </div>
                <div style="scale: 0.7; float: right">
                    <md-button
                        :disabled="workOrder.status !== WorkOrderStatus.created"
                        @click="openWorkOrder(workOrder)"
                        class="md-accent md-raised md-dense"
                    >
                        <md-icon>edit</md-icon>
                        Edit
                    </md-button>
                    <md-button @click="downloadWorkOrder(workOrder.work_order_id)" class="md-accent md-raised md-dense">
                        <md-icon>vertical_align_bottom</md-icon>
                        Download
                    </md-button>
                </div>
                <div style="clear: both"></div>
                <md-divider></md-divider>
            </div>
            <div v-if="workOrders.length === 0">Geen werkbonnen beschikbaar</div>
        </div>
    </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import * as moment from 'moment';
import * as toastr from 'toastr';
import router from '@/router';
import { IPlanningItemEntity, IWorkOrderEntity, WorkOrderApi, WorkOrderStatus } from '@phrospr/api-backend';
import { downloadFileFromApi } from '@phrospr/lib-web-core';

@Component
export default class PlanningDetailWorkOrderView extends Vue {
    public moment = moment;
    public WorkOrderStatus = WorkOrderStatus;

    get planningItem(): IPlanningItemEntity {
        return this.$store.state.planningItem;
    }

    get workOrders(): IWorkOrderEntity[] {
        return this.$store.state.workOrders;
    }

    public ownerLabel(workOrder: IWorkOrderEntity): string {
        const user = workOrder.work_order_technician_user ?? workOrder.created_by_user;
        return user ? `${user.first_name ?? ''} ${user.last_name ?? ''}`.trim() : '-';
    }

    public openWorkOrder(workOrder: IWorkOrderEntity) {
        return router.push({ path: `/workOrder/upsert/${workOrder.work_order_id}` });
    }

    public async downloadWorkOrder(work_order_id: number) {
        try {
            await downloadFileFromApi(await WorkOrderApi.downloadWorkOrder(work_order_id, { responseType: 'blob' }));
        } catch (err) {
            console.error(err);
            toastr.error('Downloaden van de werkbon is mislukt');
        }
    }
}
</script>

<style scoped>
.md-button[disabled] {
    opacity: 0.5;
}
</style>
